import React, { useState } from 'react';
import useSWR from 'swr';
import { useLocation } from 'react-router-dom';
import Hero from '../../components/catalog/hero';
import SectionCatalog from '../../components/catalog/sections/SectionCatalog/SectionCatalog';
import Layout from '../../components/global/Layout';
import { fetcher } from '../../utils/fetcher';
import { buildCatalogURL } from '../../utils/catalogUrlBuilder';

const BukuTeksK13 = () => {
  const location = useLocation();
  const [title, setTitle] = useState(location.state?.title || null);
  const [typeSearchBook, setTypeSearchBook] = useState(location.state?.typeBook || null);
  const [limit] = useState(12);
  const [typeBook, setTypeBook] = useState('type_pdf');
  const [typeCatalogue, setTypeCatalogue] = useState('getTextBooks');
  const [popularBook, setPopularBook] = useState('');
  const [latestBook, setLatestBook] = useState('');
  const [level, setLevel] = useState('');
  const [checkActive, setCheckActive] = useState('');
  const [lessonFilter, setLessonFilter] = useState([]);
  const [classFilter, setClassFilter] = useState([]);

  const endpointURL = buildCatalogURL({
    typeCatalogue,
    typeBook,
    latestBook,
    popularBook,
    title,
    typeSearchBook,
    level,
    classFilter,
    lessonFilter
  });

  const { data, isLoading, error } = useSWR(endpointURL, fetcher, {
    revalidateOnFocus: false,
    dedupingInterval: 10000,
  });

  const books = data?.results || [];

  const handleSetLevel = (type) => {
    if (checkActive === type) {
      setCheckActive('');
      setLevel('');
    } else {
      setCheckActive(type);
      setLevel(type);
    }
  };

  const filterSearchCatalogue = (data) => {
    setTitle(data.title);
    setTypeCatalogue(data.typeCatalogue);

    if (data.typeCatalogue === 'getPenggerakTextBooks') setTypeSearchBook('Kurikulum Merdeka');
    if (data.typeCatalogue === 'getTextBooks') setTypeSearchBook('Teks K13');
    if (data.typeCatalogue === 'getNonTextBooks') setTypeSearchBook('Nonteks');
  };

  const handleFilter = (data, type) => {
    const filterObject = {
      class: classFilter,
      lesson: lessonFilter,
    };

    let filterArray = filterObject[type];

    if (!filterArray.includes(data)) {
      filterArray = [...filterArray, data];
    } else {
      filterArray = filterArray.filter(item => item !== data);
    }

    switch (type) {
      case 'class':
        setClassFilter(filterArray);
        break;
      case 'lesson':
        setLessonFilter(filterArray);
        break;
      default:
        break;
    }
  };

  return (
    <Layout>
      <Hero
        typeCatalogue={typeCatalogue}
        setTypeCatalogue={(type) => {
          setTitle(null);
          setTypeCatalogue(type);
        }}
      />
      <SectionCatalog
        setLatestBook={setLatestBook}
        searchTitle={title}
        books={books}
        loading={isLoading}
        skeletonCount={limit}
        typeBook={typeBook}
        typeCatalogue={typeCatalogue}
        checkActive={checkActive}
        setTypeCatalogue={setTypeCatalogue}
        setSearchTypeCatalogue={filterSearchCatalogue}
        setTypeBook={(type) => {
          setTypeBook(type);
          setTitle(null);
        }}
        setLevel={handleSetLevel}
        setClass={(value) => handleFilter(value, 'class')}
        setLesson={(value) => handleFilter(value, 'lesson')}
        setPopularBook={setPopularBook}
      />
    </Layout>
  );
};

export default BukuTeksK13;